import React, { Component } from 'react'
import { Tabs } from 'hljd'
import TabContent from './TabContent'
import VrTabContent from './VrTabContent'
import style from './style.module.less'
import Store from './store'
import { observer } from 'mobx-react'
import { HeaderView } from '@merchant-backend/common-components'

const { TabPane } = Tabs

@observer
export default class extends Component {
  constructor() {
    super()
    this.store = new Store()
  }

  UNSAFE_componentWillMount() {
    const { tab = -1, activeKey } = this.props.location.query
    const {
      setActiveKey,
      setTab,
      getAlbumStatus,
      getVrPrivilege,
      getPhotoAlbumScene
    } = this.store
    activeKey && setActiveKey(activeKey)
    tab !== -1 && setTab(tab)
    getPhotoAlbumScene()
    getAlbumStatus()
    getVrPrivilege()
  }

  renderTabTitle = (kind, text) => {
    const { status } = this.store
    const isPass = !status[String(kind)]

    // if (kind === ALBUM_KIND.VR) {
    //   return <div className={style.badge}>{KIND_TEXT[kind]}</div>
    // }

    if (isPass) {
      return <div>{text}</div>
    }

    return (
      <div className={style.title}>
        <span className={style.content}>{text}</span>
        <i className={style.dot} />
      </div>
    )
  }

  render() {
    const { albumKind, changeTab, sceneList } = this.store
    return (
      <HeaderView
        contentStyle={{ padding: 0 }}
        className={style.container}
        title={'相册管理'}
      >
        {albumKind && (
          <Tabs
            animated={{ inkBar: true, tabPane: true }}
            activeKey={albumKind}
            onChange={changeTab}
            className={style.tab}
          >
            {sceneList.map(item => {
              if (item.id !== 0) {
                return (
                  <TabPane
                    tab={this.renderTabTitle(item.id, item.name)}
                    key={item.id}
                  >
                    <TabContent scene={String(item.id)} />
                  </TabPane>
                )
              } else {
                return (
                  <TabPane
                    tab={this.renderTabTitle(item.id, item.name)}
                    key={item.id}
                  >
                    <VrTabContent scene={String(item.id)} />
                  </TabPane>
                )
              }
            })}
          </Tabs>
        )}
      </HeaderView>
    )
  }
}
